import React from "react";

export default function Header({
  onOvertlyClick,
  onAggregateClick,
  onMapClick,
  onConscienceClick,
  onLogoClick,
}) {
  return (
    <header className="text-sm py-6">
      {/* Logo */}
      <div className="flex justify-center mb-6">
        <img
          src="/images/logo.png"
          alt="Logo"
          style={{ height: "44px", width: "119px", cursor: "pointer" }}
          onClick={onLogoClick}
        />
      </div>

      {/* Navigation */}
      <div className="grid grid-cols-4 text-center">
        <div>
          <p onClick={onOvertlyClick} className="cursor-pointer">
            Overtly Aggressive Manic Culture
          </p>
        </div>
        <div>
          <p onClick={onAggregateClick} className="cursor-pointer">
            Aggregate
          </p>
        </div>
        <div>
          <p onClick={onMapClick} className="cursor-pointer">
            Map
          </p>
        </div>
        <div>
          <p onClick={onConscienceClick} className="cursor-pointer">
            Conscience
          </p>
        </div>
      </div>
    </header>
  );
}
